<div [ngClass]="['content px-4 py-10', isAnzSSOEnabled ? 'py-8' : '']">
  <div class="close-button-container">
    <button
      type="button"
      class="close-button focus-link"
      [attr.aria-label]="'wl.anz.auth_dialog.close' | translate"
      (click)="closeDialog()">
      <rd-shared-icon class="icon" [iconSymbol]="'icon-close'"></rd-shared-icon>
    </button>
  </div>

  <ng-container *ngIf="!isAnzSSOEnabled; else anzSSOLoginTemplate">
    <h1 class="login-header">
      {{ 'wl.anz.auth_dialog.login_header' | translate }}
    </h1>
    <p class="login-description">
      {{ 'wl.anz.auth_dialog.login_description' | translate }}
    </p>

    <rd-shared-button
      class="login-button"
      [buttonClass]="'login-button'"
      [buttonContent]="loginButtonContent"
      [buttonTheme]="'primary'"
      (clickFn)="redirectToLoginUrl()">
      <ng-template #loginButtonContent>
        <span>{{ 'wl.anz.auth_dialog.login_button' | translate }}</span>
      </ng-template>
    </rd-shared-button>

    <p class="register-content">
      <span class="register-text">
        {{ 'wl.anz.auth_dialog.register_text' | translate }}
      </span>
      <a
        tabindex="0"
        class="register-link focus-link"
        (click)="redirectToEnrollUrl()"
        (keyup.enter)="redirectToLoginUrl()">
        {{ 'wl.anz.auth_dialog.register_link' | translate }}
      </a>
    </p>
  </ng-container>

  <ng-template #anzSSOLoginTemplate>
    <h1 class="login-header !mb-4">
      {{ 'wl.anz.auth_dialog.sso.login_header' | translate }}
    </h1>
    <p
      class="login-description !mb-0 !w-full px-6"
      [innerHTML]="'wl.anz.auth_dialog.sso.login_description' | translate"></p>
  </ng-template>
</div>
